import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requireApproved = true, requireAdmin = false, requireCompleteProfile = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="w-8 h-8 border-2 border-[#00e5ff] border-t-transparent rounded-full animate-spin" data-testid="loading-spinner" />
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;

  if (requireAdmin && user.role !== "admin") return <Navigate to="/board" replace />;

  if (requireApproved && user.status !== "approved" && user.role !== "admin") {
    return <Navigate to="/pending" replace />;
  }

  // Admin-mandatory 2FA gate: admins without TOTP must activate it before using the platform.
  if (
    user.role === "admin" &&
    user.totp_setup_required === true &&
    location.pathname !== "/profile"
  ) {
    return <Navigate to="/profile" replace state={{ twoFaGate: true }} />;
  }

  // Anti-tourist gate: require complete profile for platform features
  if (
    requireCompleteProfile &&
    user.status === "approved" &&
    user.role !== "admin" &&
    user.profile_complete === false &&
    location.pathname !== "/profile"
  ) {
    return <Navigate to="/profile" replace state={{ profileGate: true }} />;
  }

  return children;
}
